import { fg } from '@atlaskit/platform-feature-flags';
import { editorUGCTokens, editorUGCTokensRefreshed } from './editor-ugc-token-names';
function editorUGCToken(path) {
  var tokens;
  if (fg('platform_editor_typography_ugc')) {
    tokens = editorUGCTokensRefreshed;
  } else {
    tokens = editorUGCTokens;
  }
  return tokens[path];
}
export default editorUGCToken;